import React, { useEffect, useMemo, useState } from 'react';
import { Card, Typography } from 'antd';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { apiClient } from 'src/api/apiClient';
import { Loader } from 'src/components';
import { setAppTitle } from 'src/store/app';

import './desktopOAuthAuthorize.scss';

export const DesktopOAuthAuthorize = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  const payload = useMemo(
    () => ({
      deviceId: searchParams.get('deviceId') || '',
      redirectUri: searchParams.get('redirectUri') || '',
      state: searchParams.get('state') || ''
    }),
    [searchParams]
  );

  useEffect(() => {
    dispatch(setAppTitle('Desktop authorization'));
  }, [dispatch]);

  useEffect(() => {
    let isMounted = true;

    const run = async () => {
      if (!payload.deviceId || !payload.redirectUri) {
        if (isMounted) setError('Missing deviceId or redirectUri');
        return;
      }

      try {
        const response = await apiClient.get('/dashboard/oauth-authorize', {
          deviceId: payload.deviceId,
          redirectUri: payload.redirectUri,
          state: payload.state
        });

        const code = response?.data?.code;
        if (!code) {
          throw new Error('Authorization code was not returned');
        }

        if (isMounted) {
          setIsSuccess(true);
        }
      } catch (err) {
        if (isMounted) {
          setError(
            err?.response?.data?.message || err?.message || 'Failed to authorize desktop app'
          );
        }
      }
    };

    run();

    return () => {
      isMounted = false;
    };
  }, [payload.deviceId, payload.redirectUri, payload.state]);

  return (
    <div className="desktop-oauth-authorize">
      <Card className="desktop-oauth-authorize__card" bordered={false}>
        {error ? (
          <Typography.Text type="danger">{error}</Typography.Text>
        ) : isSuccess ? (
          <Typography.Text>Authorization completed. Return to the desktop app.</Typography.Text>
        ) : (
          <>
            <Loader />
            <Typography.Text>Authorizing desktop app...</Typography.Text>
          </>
        )}
      </Card>
    </div>
  );
};
